export { Partner as default } from "./partner";
